import React from "react";
import styled from "styled-components";
import Slide from "../../utils/images/him.jpg";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";

const Layout = styled.div`
  font-family: "Oswald", sans-serif;
  .name {
    font-size: 40px;
    color: #fff;
  }
  .desc {
    color: #fff;
    font-size: 16px;
  }
`;

function AboutHim() {
  return (
    <>
      <Layout>
        <div style={styles.banner}>
          <div>
            <h1 className="name">VICTOR UGBEDE DAVID</h1>
            <div>
              <HeartStyle>
                <span className="white-line"></span>
                <HeartFilled
                  style={{ fontSize: 19, zIndex: 20, color: "red" }}
                />
                <HeartFilled
                  style={{
                    fontSize: 19,
                    marginLeft: -5,
                    color: "white",
                  }}
                />
                <span className="white-line"></span>
              </HeartStyle>
            </div>
            <p className="desc">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
              ultrices <br />
              malesuada ante quis pharetra. Nullam non bibendum dolor. Ut vel
              turpis
            </p>
          </div>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    background: `linear-gradient(0deg,rgba(125,50,210,0.5),rgba(0,170,110,0.5)),url(${Slide})`,
    height: 530,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    display: "grid",
    placeItems: "center",
    textAlign: "center",
  },
};
export default AboutHim;
